<template>
    <div id="enNew">
            <img :src="list.pic" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
            <div class="endowloadDetail-contaniner">
              <div class="con-head">
                 <h1 class="name">{{list.name}}</h1>
                <div class="time">{{list.createTime}}</div>
              </div>
               <div class="qu-con">
                 <div v-html="list.content"></div>
               </div>
            </div>
        <goTop></goTop>
    </div>
</template>
<script>
import { newsDetail} from "@/api/enterprise/index" // 解决方案详情
import LocaStorage from "../../utils/localstorage.js"
import goTop from '@/components/goTop'
import debounce from '../../utils/debounce.js' //防抖
import "../../assets/styles/font.css";
export default {
    name:'enNewsDetail',
    data() {
        return {
            currentNav:0,
            list:{},
            tabPosition:'top',
            isFixed: false,
            isClick:false,
            lotoken:false,
            appGl:[],
            contentTopList:[],
        }
    },
    components:{
        goTop
    },
     mounted() {
  },
    created () {
        this.lotoken = LocaStorage.setAge().get('token1') ? true : false
        this.getInfo()
    },
    methods: { 
        // 获取详情
         getInfo(){
              newsDetail({
                id:this.$route.query.id,
            },'enterprise')
            .then(res => {
              console.log(res)
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
              res.code == 0 ?  this.list = res.data : this.list = {}
              // this.appGl = res.data.solutionContentList
              document.title= res.data.name
               if(this.list){
                           this.$nextTick(function(){
                 const imgDomArray = document.getElementById('enNew')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
                }
            })
            .catch(err => {

            })
        },
    },
}
</script>
<style lang="scss" scoped>
#enNew{
          .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
        }
        .con-head{
          position: relative;
          text-align: center;
          padding:30px 0;
          .name{
            font-size: 32px;
            letter-spacing: 7px;
            margin-bottom: 0;
            text-shadow: 1px 1px 2px rgb(0 0 0 / 30%);
            color: inherit;
          }
          .time{
            color: #ccc;
          }
        }
        .endowloadDetail-head{
        position: relative;
        .bg-overlay{
          width: 1170px;
          margin: 0 auto;
          color: #fff;
          text-align: center;
          .name{
            font-size: 32px;
            letter-spacing: 7px;
            margin-bottom: 0;
            text-shadow: 1px 1px 2px rgb(0 0 0 / 30%);
            color: inherit;
          }
          .time{
            color: #ccc;
          }
        }
    }
    .endowloadDetail-contaniner{
      width: 100%;
      margin: 0 auto;
    }
}
@media (max-width: 640px){
  #enNew{
    margin-top: -56px;
    .banner-img{
      height: auto;
    }
    .endowloadDetail-contaniner{
      width: 80%;
      margin: 0 auto;
    }
  }
  .endowloadDetail-head{
    width: 100%;
    padding: 50px 0 !important;
    .bg-overlay{
      width: 100% !important;
    }
  }
  .qu-con{
width: 100% !important;
  }
}
</style>